import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-modal-share-qr',
    templateUrl: './modal-share-qr.component.html',
    standalone: false
})
export class ModalShareQrComponent implements OnInit {
    link: string;

    constructor(
        public dialogRef: MatDialogRef<ModalShareQrComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.link = data.link;
    }

    ngOnInit(): void {
    }

    close(): void {
        this.dialogRef.close();
    }
}
